import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idUser: number;
};

export const getUserStackActivity = async (
  params: Params
): Promise<null | number> => {
  const response = await customFetch(
    getM8AdminURL(`getUserStackActivity?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
